import { z } from "zod";

import { EducationAndQualificationType } from "../-zod-schema";

export const OrderBy = {
  CERTIFICATION_NAME: "CERTIFICATION_NAME",
  CERTIFICATION_NUMBER: "CERTIFICATION_NUMBER",
  LAST_RENEWAL_DATE: "LAST_RENEWAL_DATE",
  VALID_TO: "VALID_TO",
  RENEWAL_DEADLINE: "RENEWAL_DEADLINE",
} as const;

export const EducationAndQualificationSearchSchema = z.object({
  sortOrder: z.enum(["asc", "desc"]).default("asc").optional(),
  sortColumn: z
    .union([
      z.nativeEnum(OrderBy),
      z.enum([
        "certificationName",
        "certificationNumber",
        "lastRenewalDate",
        "validTo",
        "renewalDeadline",
      ]),
    ])
    .optional(),
  freeText: z.string().optional(),
  page: z.number().default(1),
  pageSize: z.number().default(100),
  educationAndQualificationType: z
    .nativeEnum(EducationAndQualificationType)
    .default(EducationAndQualificationType.CERTIFICATION),
});
